import React from 'react';

import LogoImage from '../../assets/brussels-logo.png';
import './styles.scss';

const Logo: React.FC = () => (
  <a className="upper-header-container" href="https://www.brusselsairlines.com/">
    <img className="logo" src={LogoImage} alt="Brussels Airlines logo" />
  </a>
);

export default Logo;
